import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	externalLinkRequestFormIconLabel: {
		id: 'servicedesk-external-links.links.link.external-link-request-form-icon-label',
		defaultMessage: 'External request form',
		description: 'Label for Request form external link icon',
	},
	externalLinkKnowledgeIconLabel: {
		id: 'servicedesk-external-links.links.link.external-link-knowledge-icon-label',
		defaultMessage: 'Self-help resources',
		description: 'Label for knowledge external link icon',
	},
	externalLinkChannelIconLabel: {
		id: 'servicedesk-external-links.links.link.external-link-channel-icon-label',
		defaultMessage: 'Communication channel',
		description: 'Label for help channel external link icon',
	},
	externalLinkOtherIconLabel: {
		id: 'servicedesk-external-links.links.link.external-link-other-icon-label',
		defaultMessage: 'Other',
		description: 'Label for other external link icon',
	},
	externalLinkRemoveButtonLabel: {
		id: 'servicedesk-external-links.links.link.external-link-remove-button-label',
		defaultMessage: 'Remove {title}',
		description: 'Label for exernal link delete button',
	},
	externalLinkRemoveButtonTooltip: {
		id: 'servicedesk-external-links.links.link.external-link-remove-button-tooltip',
		defaultMessage: 'Remove link',
		description: 'Label for external link remove button tooltip',
	},
	externalLinkTitleTooltip: {
		id: 'servicedesk-external-links.links.link.external-link-title-tooltip',
		defaultMessage: 'Opens in new tab',
		description: 'Label for external link title tooltip',
	},
	externalLinkUpdateButtonLabel: {
		id: 'servicedesk-external-links.links.link.external-link-update-button-label',
		defaultMessage: 'Edit {title}',
		description: 'Label for exernal link edit button',
	},
	externalLinkUpdateButtonTooltip: {
		id: 'servicedesk-external-links.links.link.external-link-update-button-tooltip',
		defaultMessage: 'Edit link',
		description: 'Label for external link edit button tooltip',
	},
});
